export default __webpack_public_path__ + "static/media/refrigertors.335f0b44.png";